import axios from "axios";
import { CompanyInt } from "../typescript/interfaces/CompanyInt";
import { JobInt } from "../typescript/interfaces/JobInterface";
import { environment } from "../config/enviroment";
import { getToken as getAppCheckToken } from "firebase/app-check";
import { appCheck } from "../firebase";

export const createCompany = async (companyData: CompanyInt) => {
  const appCheckToken = await getAppCheckToken(appCheck);
  const response = await axios.post(
    `${environment.endpoints.createCompany}`,
    companyData,
    {
      headers: {
        "X-Firebase-AppCheck": appCheckToken.token,
      },
    }
  );

  return response.data;
};

export const getCompanyByUser = async (id: string) => {
  const appCheckToken = await getAppCheckToken(appCheck);
  try {
    const response = await axios.get(
      `${environment.endpoints.getCompanyByUser}?id=${id}`,
      {
        headers: {
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );

    return response.data.company;
  } catch (error) {
    console.error("Error fetching company by user:", error);
    throw error;
  }
};
// deduct post from company and Posts Job
export const deductPostFromCompany = async (companyId: string, job: JobInt) => {
  try {
    const appCheckToken = await getAppCheckToken(appCheck);
    console.log("deducting post from company");
    console.log(job);
    console.log(companyId);

    const result = await axios.post(
      `${environment.endpoints.deductPostFromCompany}`,
      { companyId, jobData: job },
      {
        headers: {
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );

    return result.data.message;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.message);

      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
    } else {
      console.error("Unexpected error:", error);
    }
    return "An error occurred while deducting the post.";
  }
};

export const getApplicantsByCompanyId = async (
  id: string,
  page: number,
  limit: number,
  searchTerm: string,
  filters: { [key: string]: string }
) => {
  try {
    const appCheckToken = await getAppCheckToken(appCheck);
    const params = new URLSearchParams({
      id,
      page: page.toString(),
      limit: limit.toString(),
      searchTerm: searchTerm,
      filters: JSON.stringify(filters),
    });

    const response = await axios.get(
      `${environment.endpoints.getApplicantsByCompanyId}?${params.toString()}`,
      {
        headers: {
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching applicants by company id:", error);
    throw error;
  }
};
